module.exports = __webpack_public_path__ + "img/emoji_020.36130cb9.png";